import React from 'react';
import {Redirect, Route, Switch} from "react-router-dom";
import DefaultRoute from 'routes/DefaultRoute';
import {PageRouteProps, routes} from 'routes/routesMain';
import ErrorPage from "components/error/ErrorPage";

function Main() {
    return (
        <Route>
            <Switch>
                <Redirect exact from="/main" to="/main/user_main"/>
                {routes.map((_item: PageRouteProps, _index: number) => {
                    return (
                        <DefaultRoute
                            exact
                            key={_index}
                            path={_item.path}
                            layout={_item.layout}
                            component={_item.component}
                        />
                    );
                })}
                <Route>
                    <ErrorPage/>
                </Route>
                {/*  */}
            </Switch>
        </Route>
    );
}

export default Main;